{
    "LicenseManagement_Title": "GESTÃO DE LICENÇAS EMPRESARIAIS",
    "LicenseManagement_Heading_License": "Licença",
    "LicenseManagement_Heading_Quantity": "Quantidade",
    "LicenseManagement_Essentials": "Essenciais",
    "LicenseManagement_Essentials_MST": "Norma CXA",
    "LicenseManagement_Professional": "Profissional",
    "LicenseManagement_Professional_MST": "CXA Premium",
    "LicenseManagement_Enterprise": "Empresa",
    "LicenseManagement_Enterprise_MST": "CXA Avançado",
    "LicenseManagement_CallCentreAgent": "Agente do centro de atendimento",
    "LicenseManagement_CallCentreAgent_MST": "CXE Premium",
    "LicenseManagement_CallCentreSupervisor": "Supervisor do centro de atendimento",
    "LicenseManagement_CallCentreSupervisor_MST": "CXE Avançado",
    "LicenseManagement_Validation_Number": "Deve ser um número válido",
    "LicenseManagement_Validation_Limit": "Excede o limite da licença CME. Deve ser inferior ou igual a {}",
    "LicenseManagement_Validation_Limit_Reached": "Excede o limite máximo da licença CME. Não há mais licenças disponíveis",
    "LicenseManagement_Validation_MAX_LIMIT": "O número excede o número máximo permitido",
    "LicenseManagement_Validation_POSITIVE_NUMBER": "O número deve ser positivo",
    "NAME": "LicenseManagement",
    "LicenseManagement_CXIntegration": "Integração CX"
}